import { render, staticRenderFns } from "./SettingsCopyrights.vue?vue&type=template&id=6ff63730&scoped=true"
import script from "./SettingsCopyrights.vue?vue&type=script&lang=js"
export * from "./SettingsCopyrights.vue?vue&type=script&lang=js"
import style0 from "./SettingsCopyrights.vue?vue&type=style&index=0&id=6ff63730&prod&lang=scss&scoped=true"
import style1 from "vue-select/dist/vue-select.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff63730",
  null
  
)

export default component.exports